export default __webpack_public_path__ + "static/media/oxygen-grey.e4cc5a39.svg";